import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartProvider'; // Import the cart
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import './SuccessPage.css';

function SuccessPage() {
  const { clearCart } = useCart(); // Get the clearCart function

  // When this page loads, we clear the cart
  useEffect(() => {
    clearCart();
  }, []); // <-- THIS IS THE FIX (Empty dependency array)

  return (
    <>
      <Nav />
      <div className="success-container">
        <div className="success-box">
          <div className="success-icon">✓</div>
          <h2>Payment Successful!</h2>
          <p>Thank you for your purchase. Your order is being processed.</p>
          <Link to="/" className="success-home-button">
            Continue Shopping
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SuccessPage;
